<template>
  <div class="card status-card">
    <p class="eyebrow">Workshop</p>
    <h1>{{ title }}</h1>
    <p class="lead">{{ body }}</p>
    <p v-if="collegeName" class="college muted">
      {{ collegeName }}
    </p>
    <div class="actions">
      <button
        v-if="canEnter"
        class="btn btn-primary"
        @click="router.push('/slides/01')"
      >
        Enter the workshop
      </button>
      <button class="btn btn-secondary" :disabled="signingOut" @click="logout">
        {{ signingOut ? 'Signing out…' : 'Sign out' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getMe } from '../services/api'
import { signOutAndLeave } from '../services/auth'
import { canEnterWorkshop } from '../services/workshopAccess'

const router = useRouter()
const me = ref(null)
const signingOut = ref(false)
const collegeName = computed(() => me.value?.collegeName || '')
const canEnter = computed(() => canEnterWorkshop(me.value))
const title = computed(() => canEnter.value ? 'Your workshop is ready' : 'Thanks for your interest')
const body = computed(() => {
  if (canEnter.value) return 'You are approved. You can open the workshop slides at any time.'
  if (me.value?.status === 'approved') {
    return me.value?.collegeId && me.value?.sessionEnabled === false
      ? 'Access for this college is disabled. Please contact a facilitator.'
      : 'Please ask a facilitator to confirm your college assignment.'
  }
  return 'Your registration is waiting for facilitator approval. Once approved, you can access the slides at any time.'
})
async function logout() {
  if (signingOut.value) return
  signingOut.value = true
  try { await signOutAndLeave() } catch { signingOut.value = false }
}
onMounted(async () => {
  try { me.value = await getMe() } catch { me.value = null }
  if (me.value?.status === 'removed' || me.value?.status === 'rejected' ||
      (!me.value?.collegeId && !me.value?.collegeName)) router.replace('/select-college')
})
</script>

<style scoped>
.status-card {
  max-width: 32rem;
  margin: 0 auto;
  text-align: left;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--teal);
  margin: 0 0 0.5rem;
}

h1 {
  margin: 0 0 0.75rem;
  font-size: 1.75rem;
}

.lead {
  margin: 0 0 0.75rem;
  font-size: 1.05rem;
}

.college {
  margin: 0 0 1.5rem;
  font-weight: 600;
}

.actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
</style>
